import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { /*educationAdventure,*/ ImageUrl } from '../../utils/constants';
// import moment from 'moment';
import { commaSeperator, convertMilesToKm, fetchApi } from '../../utils/methods';
import { /*CountDiv,*/ DropdownContent, IconWrapper, /*InitativeCard,*/ InterestCard, /*NewTotalPoints, NewTotalPointsV2, WellnessCard,*/ WellnessCardNew } from './styles';
import { fetchAdventureScoreBoard, getChallengeParticipation,getFitnessGoals,getWellnessInterests } from '../../redux/actions';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import LazyImage from '../common/LazyImage/LazyImage';
import { Divider } from '../Manager/styles';
import { MilesIcon, StepsIcon, TimeIcon, DropIcon, PencilIconNew, WellnessChallengeIcon, ClassicChallengeIcon, SurvivorChallengeIcon, GroupChallengeIcon, GlobalChallengeIcon, FitnessIcon, RecipeVideosIcon, ArticlesReadIcon, QuizPassedIcon, LiveEventIcon, OnDemandEventIcon, DailyTipIcon } from '../../utils/icons';
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import { GetFitnessActivity } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
// import {getLastSyncDetails} from "../../utils/methods";
const filterOption = ["Daily","Monthly","Yearly"];

const WellnessData = [
  "Individual Sports",
  "Water Sports",
  "Ball Sports",
  "Wheel Sports",
  "Winter Sports",
  "Combat Sports",
  "Resistance Training",
  "Other"
];

const fitnessData = [
  'health',
  'behavioral',
  'performance',
  'racing/competition'
];

const scoresDetails = [
  {
    color: '#B1AA56',
    width: '100%',
    value: 20,
    content: 'out of 30 lifestyle adventures completed',
    image: 'fitnessvideow.png',
    overlap: false
  },
  {
    color: '#92A4DA',
    width: '100%',
    value: 10,
    content: 'out of 25 readings completed',
    image: 'recipevideow.png',
    overlap: false
  },
  {
    color: '#DA9B6C',
    width: '100%',
    value: 2,
    content: 'out of 25 quizzes completed',
    image: 'ReadingCompletedn.png',
    overlap: false
  },
  {
    color: '#DA92C8',
    width: '100%',
    value: 2,
    content: 'out of 25 quizzes completed',
    image: 'educationNew.png',
    overlap: false
  },
  {
    color: '#DA6C74',
    width: '100%',
    value: 2,
    content: 'Daily Tips Seen',
    image: 'liveEvents.png',
    overlap: false
  },
  {
    color: '#92A4DA',
    width: '100%',
    value: 2,
    content: 'Daily Tip Points Earned',
    image: 'onDemandEvents.png',
    overlap: false
  },
  {
    color: '#DA9B6C',
    width: '100%',
    value: 12,
    content: 'perfect score on the quizzes',
    image: 'tip.png',
    overlap: false
  },
];

class WellnessWellbeing extends Component {
  constructor() {
    super();
    this.state = {
      scoresDetails: null,
      activeIndex:[],
      interestData:true,
      filterOptions:filterOption,
      timeInterval:"Yearly",
      activeFitnessIndex:[],
      fitnessActivityData:null
    }
  }

  handleDropDown = (index) => {
    this.setState((prevState) => {
      const { activeIndex } = prevState;
      if (activeIndex.includes(index)) {
        // If index is already in the array, remove it (close dropdown)
        return { activeIndex: activeIndex.filter((i) => i !== index) };
      } else {
        // Otherwise, add it (open dropdown)
        return { activeIndex: [...activeIndex, index] };
      }
    });
  };

  handleFitnessGoalDropDown = (index) => {
    this.setState((prevState) => {
      const { activeFitnessIndex } = prevState;
      if (activeFitnessIndex.includes(index)) {
        // If index is already in the array, remove it (close dropdown)
        return { activeFitnessIndex: activeFitnessIndex.filter((i) => i !== index) };
      } else {
        // Otherwise, add it (open dropdown)
        return { activeFitnessIndex: [...activeFitnessIndex, index] };
      }
    });
  };


  handleTimeIntervalChange = (selectedOption) => {
    this.setState({timeInterval:selectedOption});
    this.fetchFitnessActivity(selectedOption?.toLowerCase());
  };
    

  componentDidMount = () => {
    const { adventureScoreBoard, fetchAdventureScoreBoard, getChallengeParticipation,fetchWellnessInterests,wellnessInterests,fetchFitnessGoals,fitnessGoals } = this.props;
    if (!adventureScoreBoard) {
      fetchAdventureScoreBoard();
    }
    else {
      this.setScore(adventureScoreBoard);
    }
    const currentYear = new Date().getFullYear();
    const year = currentYear;
    getChallengeParticipation(year);

    if (!wellnessInterests) fetchWellnessInterests();
    if(!fitnessGoals)fetchFitnessGoals()
    this.fetchFitnessActivity("yearly");
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { adventureScoreBoard/*, fetchAdventureScoreBoard*/ } = nextProps;
    if (adventureScoreBoard) {
      this.setScore(adventureScoreBoard);
    } 
    // else {
    //   fetchAdventureScoreBoard();
    // }
  }

  setScore = (adventureScoreBoard) => {
    let arr = [...scoresDetails];

    for (let i = 0; i < arr.length; i++) {
      switch (i) {
      case 0:
        arr[i].value = adventureScoreBoard.fitness_videos_count;
        arr[i].content = `${this.props.t('Fitness videos watched')}`;
        arr[i].icon = FitnessIcon();
        break;
      case 1:
        arr[i].value = adventureScoreBoard.recipe_videos_count;
        arr[i].content = `${this.props.t('Recipe videos watched')}`;
        arr[i].icon = RecipeVideosIcon();
        break;
      case 2:
        arr[i].value = adventureScoreBoard.read_journeys_count;
        arr[i].content = `${this.props.t('Articles read')}`;
        arr[i].icon = ArticlesReadIcon();
        break;
      case 3:
        arr[i].value = adventureScoreBoard.completed_quizzes_count;
        arr[i].content = `${this.props.t('Quizzes passed')}`;
        arr[i].icon = QuizPassedIcon();
        break;
      case 4:
        arr[i].value = adventureScoreBoard.recipe_videos_point;
        arr[i].content = `${this.props.t('Live events attended')}`;
        arr[i].icon = LiveEventIcon();
        break;
      case 5:
        arr[i].value = adventureScoreBoard.fitness_videos_count;
        arr[i].content = `${this.props.t('On-demand events watched')}`;
        arr[i].icon = OnDemandEventIcon();
        break;
      case 6:
        arr[i].value = adventureScoreBoard.daily_tip_seen;
        arr[i].content = `${this.props.t('Daily tips viewed')}`;
        arr[i].icon = DailyTipIcon();
        break;
      }
    }
    this.setState({
      scoresDetails: arr
    })
  }

  fetchFitnessActivity = async(filter)=>{

    window.console.log("filter",filter)
    const {uid}=this.props.user
    const res = await fetchApi(GetFitnessActivity + "/" + uid + "/" + filter,"GET");
    if(res.status === "success"){
      this.setState({fitnessActivityData:res.data})
    }else{
      toast(res?.data?.message)
    }

  }

  render() {
    const { /*dailyActivityData,*/ workoutActivityCount, history, participantCount,wellnessInterests,interest,fitnessGoals, selectedFitnessGoals } = this.props;
    const{fitnessActivityData} = this.state;
    const DistanceUnit = localStorage.getItem('DISTANCE');

    // let Total = participantCount.behavior_challenge_count + participantCount.classic_challenge_count + participantCount.group_challenge_count + participantCount.survivor_challenge_count
    return (
      <div>
        <WellnessCardNew>
          <div className='heading'  onClick={() => history.push('/workout-history')} style={{cursor:"pointer"}}>  My Workout History </div>
          <Divider id="divider" isMargin={"20px 0px"}></Divider>
          <div className="wellness-interest">
            {workoutActivityCount?.workout_details?.length > 0 && workoutActivityCount?.workout_details?.map((data, index) =>
              (
                <div className="wellnessTypeContainer" key={index}>
                  <IconWrapper isColor={data?.bg_color || "#B1AA56"}>
                    <LazyImage style={{padding: '7px',width:"48px"}} src={`${ImageUrl}/${data.interest_white_icon}`} />
                    {/* {EventsWatchedIcon()} */}
                  </IconWrapper>
                  <div>
                    <div className='activity-name'>{this.props.t(data?.activity)}</div>
                    <div className='activity-count'>{this.props.t(data?.activity_count) > 0 &&  this.props.t(data?.activity_count) < 10 ? `0${this.props.t(data?.activity_count)}`: this.props.t(data?.activity_count)}</div>
                  </div>
                </div>
              ))
            }
          </div>
          {/* <div className="wellness-interest">
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#B1AA56"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Dance</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#92A4DA"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Hiking</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#DA9B6C"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Badminton</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#DA92C8"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Yoga</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#75B084"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Running</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#DA6C74"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Walking</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#92A4DA"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Swimming</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#DA9B6C"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Cricket</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#B1AA56"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Football</div>
                <div>27</div>
              </div>
            </div>
            <div className="wellnessTypeContainer">
              <IconWrapper isColor={"#DA92C8"}>
                {EventsWatchedIcon()}
              </IconWrapper>
              <div>
                <div>Meditation</div>
                <div>27</div>
              </div>
            </div>
          </div> */}
        </WellnessCardNew>

        <div style={{ display: 'flex', gap:"20px" }}>
          <WellnessCardNew>
            <div className="headerContainer">
              <div className='heading'>My Fitness Activity </div>
              <CommonFilterDropdown
                options={this.state.filterOptions}
                selectedOption={this.state.timeInterval}
                setSelectedOption={this.handleTimeIntervalChange}
                dropdownHeight={"auto"}
              />
            </div>
            <Divider id="divider" isMargin={"20px 0px"}></Divider>
            <div className="wellness-interest">
              <div style={{ display: 'flex',flexDirection:"column",width:"150px",gap:"12px",alignItems:"center",justifyContent:"center",borderRight: '1px solid #EFEFEF', }}>
                <IconWrapper isColor={"#92A4DA"}>
                  {StepsIcon()}
                </IconWrapper>
                <div className="value">{_.isUndefined(fitnessActivityData?.steps) ? 0 : commaSeperator(parseInt(fitnessActivityData?.steps,10))} Steps</div>
              </div>

              <div style={{ display: 'flex',flexDirection:"column",width:"150px",gap:"12px",alignItems:"center",justifyContent:"center",borderRight: '1px solid #EFEFEF', }}>
                <IconWrapper isColor={"#DA6C74"}>
                  {MilesIcon()}
                </IconWrapper>
                <div className="value"> {_.isUndefined(fitnessActivityData?.distance) ? 0 : DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(fitnessActivityData?.distance)) : commaSeperator(parseInt(fitnessActivityData?.distance,10))}
                  <span>&nbsp;&nbsp;{DistanceUnit === "KILOMETER" ? "Km" : this.props.t("Miles")}</span></div>
              </div>

              <div style={{ display: 'flex',flexDirection:"column",width:"150px",gap:"12px",alignItems:"center",justifyContent:"center",borderRight: '1px solid #EFEFEF', }}>
                <IconWrapper isColor={"#B1AA56"}>
                  {TimeIcon()}
                </IconWrapper>
                {/* <div className="value">{_.isUndefined(fitnessActivityData?.calories) ? 0 : commaSeperator(parseInt(fitnessActivityData?.calories,10))}</div> */}
                <div className="value">{_.isUndefined(fitnessActivityData?.total_time) ? 0 : fitnessActivityData?.total_time}</div>
              </div>
            </div>
          </WellnessCardNew>
          {/* <WellnessCardNew>
            <div className='heading'>Wellness Goals</div>
            <Divider id="divider" isMargin={"20px 0px"}></Divider>
          </WellnessCardNew> */}
        </div>

        <WellnessCardNew>
          <div className='heading'>Wellness Interests</div>
          <Divider id="divider" isMargin={"20px 0px"}></Divider>
          {WellnessData.map((data,index)=>(
            <InterestCard key={index} >
              <div className="interest-container" onClick={()=>this.handleDropDown(index)}>
                <div className="interestType">{data}</div>
                <div  style={{   transform: this.state.activeIndex.includes(index) ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"}} className="dropicon"> {DropIcon("#F37A65")}</div>
              </div>
              {this.state.activeIndex.includes(index) && (
                <div className="dropdown-wrapper">
                  {wellnessInterests.map((listData, index) => {
                    const isMatchingInterest = interest?.some((item) => item?.interest_id === listData?.id); // Check if listData?.id exists in interest array
                    if (data.toLowerCase().trim() === (this.state.interestData ? listData?.interest_type.toLowerCase().trim() : listData?.goal_type.toLowerCase().trim())) {
                      return (
                        <DropdownContent userInterest={isMatchingInterest} key={index}>
                          {this.state.interestData && isMatchingInterest  ?  <img src={`${ImageUrl}/${listData?.interest_white_icon}`} /> :  <img src={`${ImageUrl}/${listData?.interest_color_icon}`} />}
                          <div className="listContent">{listData?.name}</div>
                        </DropdownContent>
                      );
                    }
                  })}
                </div>
              )}
            </InterestCard>))}
        </WellnessCardNew>

        <WellnessCardNew>
          <div className='heading-row'>
            <div className='heading'>Fitness Goals</div>
            <div className='edit-btn' onClick={() => history.push({pathname:'/settings',state:{eventKey:2}})}>Edit <span className='pencil-icon'>{PencilIconNew()}</span></div>
          </div>
          <Divider id="divider" isMargin={"20px 0px"}></Divider>
          {fitnessData.map((data,index)=>(
            <InterestCard key={index} >
              <div className="interest-container" onClick={()=>this.handleFitnessGoalDropDown(index)}>
                <div className="interestType">{data}</div>
                <div  style={{   transform: this.state.activeFitnessIndex.includes(index) ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"}} className="dropicon"> {DropIcon("#F37A65")}</div>
              </div>
              {this.state.activeFitnessIndex.includes(index) && (
                <div className="dropdown-wrapper">
                  {fitnessGoals?.map((listData, index) => {
                    const isMatchingFitnessActivity = [...selectedFitnessGoals.top_goals, ...selectedFitnessGoals.other_goals].some((item) => item.id === listData?.id); // Check if listData.id exists in interest array
                    if (data?.toLowerCase()?.trim() === (this.state.interestData ? listData?.goal_type?.toLowerCase()?.trim() : listData.goal_type?.toLowerCase()?.trim())) {
                      return (
                        <DropdownContent userInterest={isMatchingFitnessActivity} key={index}>
                          {/* {this.state.interestData && <img src={`${ImageUrl}/${listData.interest_image}`} />} */}
                          <div className="listContent">{listData?.name}</div>
                        </DropdownContent>
                      );
                    }
                  })}
                </div>
              )}
            </InterestCard>))}
        </WellnessCardNew>

        {scoresDetails?.length > 0 ?  <WellnessCardNew isMin={"295px"}  isMax={"295px"}>
          <div className='heading'>  My Wellness Activities </div>
          <Divider id="divider" isMargin={"20px 0px"}></Divider>
          <div className="wellness-interest">
            {scoresDetails && scoresDetails.length > 0 && scoresDetails.map((data, index) => (
              <div key={index} className="wellnessTypeContainer">
                <IconWrapper isColor={data.color}>
                  {data.icon}
                </IconWrapper>
                <div>
                  <div className="contentHeading">{data.content}</div>
                  <div className="value">{data.value > 0 && data.value < 10 ? `0${data.value}` : data.value}</div>
                </div>
              </div>
            ))}
          </div>
        </WellnessCardNew>:null}

        { this.props.companyBranding?.company_branding?.show_challenge ?
          <WellnessCardNew isMin={"295px"}  isMax={"295px"}>
            <div className='heading'>My Challenge Participation </div>
            <Divider id="divider" isMargin={"20px 0px"}></Divider>
            <div className="wellness-interest">
              <div className="wellnessTypeContainer">
                <IconWrapper isColor={"#B1AA56"}>
                  {WellnessChallengeIcon()}
                </IconWrapper>
                <div>
                  <div className="contentHeading">Wellness challenges</div>
                  <div className="value">{participantCount.behavior_challenge_count > 0  &&participantCount.behavior_challenge_count < 10 ? `0${participantCount.behavior_challenge_count}`  : participantCount.behavior_challenge_count }</div>
                </div>
              </div>
              <div className="wellnessTypeContainer">
                <IconWrapper isColor={"#92A4DA"}>
                  {ClassicChallengeIcon()} 
                </IconWrapper>
                <div>
                  <div className="contentHeading">Classic challenge</div>
                  <div className="value">{participantCount.classic_challenge_count > 0 && participantCount.classic_challenge_count < 10 ? `0${participantCount.classic_challenge_count}`: participantCount.classic_challenge_count} </div>
                </div>
              </div>
              <div className="wellnessTypeContainer">
                <IconWrapper isColor={"#DA9B6C"}>
                  {SurvivorChallengeIcon()}
                </IconWrapper>
                <div>
                  <div className="contentHeading">Survivor challenge</div>
                  <div className="value"> {participantCount.survivor_challenge_count >0 && participantCount.survivor_challenge_count <10 ? `0${participantCount.survivor_challenge_count}`: participantCount.survivor_challenge_count}</div>
                </div>
              </div>
              <div className="wellnessTypeContainer">
                <IconWrapper isColor={"#DA92C8"}>
                  {GroupChallengeIcon()}
                </IconWrapper>
                <div>
                  <div className="contentHeading">Group challenge</div>
                  <div className="value"> {participantCount.group_challenge_count > 0 &&  participantCount.group_challenge_count < 10 ? `0${participantCount.group_challenge_count}`:participantCount.group_challenge_count}</div>
                </div>
              </div>
              <div className="wellnessTypeContainer">
                <IconWrapper isColor={"#DA6C74"}>
                  {GlobalChallengeIcon()}
                </IconWrapper>
                <div>
                  <div className="contentHeading">Global challenges</div>
                  <div className="value">{participantCount.global_challenge_count > 0 && participantCount.global_challenge_count < 10 ? `0${participantCount.global_challenge_count}`:participantCount.global_challenge_count}</div>
                </div>
              </div>
            </div>
          </WellnessCardNew>:null}




        {/* <InitativeCard>
          <div className='company-initative'>
            <div className='heading'>
              {this.props.t("My")} {moment().format('YYYY')} {this.props.t("Fitness Activity")} &nbsp;
            </div>
            <hr className='horizontal-line2' />
            <div className='fitness-wrapper'>
              <NewTotalPoints>
                <LazyImage src={ImageUrl + "/images/behaviorChallenges/RunSteps.png"}/>
                <div>
                  <div>{this.props.t("Total Steps Walked")}</div>
                  <CountDiv style={{ color: '#32DBC6' }}>
                    {_.isUndefined(dailyActivityData.steps) ? 0 : commaSeperator(parseInt(dailyActivityData.steps,10))}
                    <span>&nbsp;&nbsp;{this.props.t("Steps")}</span>
                  </CountDiv>
                </div>
              </NewTotalPoints>
              <NewTotalPoints>
                <LazyImage src={ImageUrl + "/images/behaviorChallenges/Calories.png"}/>
                <div>
                  <div>{this.props.t("Total Calories Burned")} </div>
                  <CountDiv style={{ color: '#F6B479' }}>
                    {_.isUndefined(dailyActivityData.calories) ? 0 : commaSeperator(parseInt(dailyActivityData.calories,10))}
                    <span>&nbsp;&nbsp;{this.props.t("Calories")}</span>
                  </CountDiv>
                </div>
              </NewTotalPoints>
              <NewTotalPoints>
                <LazyImage src={ImageUrl + "/images/behaviorChallenges/distanceNew.png"}/>
                <div>
                  <div>{this.props.t("Distance Traveled")}</div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    {_.isUndefined(dailyActivityData.distance) ? 0 : DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(dailyActivityData.distance)) : commaSeperator(parseInt(dailyActivityData.distance,10))}
                    <span>&nbsp;&nbsp;{DistanceUnit === "KILOMETER" ? "Km" : this.props.t("Miles")}</span>
                  </CountDiv>
                </div>
              </NewTotalPoints>
            </div>
          </div>
        </InitativeCard> */}
       


        {/* {workoutActivityCount && workoutActivityCount.workout_details.length > 0 ? <WellnessCard>
          <div className='wellness-interest'>
            <div className='wellness-title'>
              <span className='title-text'>{this.props.t("My")} {moment().format('YYYY')} {this.props.t("Workout History")}</span>
              <span className='wellness-count'>{`(${this.props.t("Total")} : ${workoutActivityCount.workout_details.length})`}</span>
              <button onClick={() => history.push('/workout-history')} className='user-edit-btn'>{this.props.t("View Details")}</button>
            </div>
            <hr className='horizontal-line' />
            <div className='interest-card-wrapper'>
              {workoutActivityCount.workout_details.length > 0 && workoutActivityCount.workout_details.map((data, index) =>
                (
                  <NewTotalPointsV2 key={index} marginRight={(index + 1) % 4 === 0 ? "0px" : "25px"}>
                    <div>
                      <img style={{padding: '7px'}} src={`${ImageUrl}/${data.interest_icon}`} />
                    </div>
                    <div>
                      <div>{this.props.t(data.activity)}</div>
                      <CountDiv style={{ color: '#69C2FF' }}>
                        <div>{this.props.t(data.activity_count)}</div>
                      </CountDiv>
                    </div>
                  </NewTotalPointsV2>
                ))
              }
            </div>
          </div>
        </WellnessCard> : null} */}


        {/* {scoresDetails?.length > 0 ? <InitativeCard>
          <div className='company-initative'>
            <div className='heading'>
              {this.props.t("My")} {moment().format('YYYY')} {this.props.t("Wellness Activities")} &nbsp;
            </div>
            <hr className='horizontal-line2' />
            <div className='fitness-wrapper'>
              {scoresDetails && scoresDetails.length > 0 && scoresDetails.map((data, index) => (
                <>
                  {data.value !== 0 ? <NewTotalPoints key={index}>
                    <div>
                      <img src={educationAdventure + data.image} />
                    </div>
                    <div>
                      <div>{this.props.t(data.content)}</div>
                      <CountDiv style={{ color: '#69C2FF' }}>
                        {this.props.t(data.value)}
                      </CountDiv>
                    </div>
                  </NewTotalPoints>:null}</>))}
            </div>
          </div>
        </InitativeCard>:null} */}


        {/* {this.props.companyBranding?.company_branding?.show_challenge ? <InitativeCard>
          <div className='company-initative'>
            <div className='heading'>
              {this.props.t("My")} {moment().format('YYYY')} {this.props.t("Challenge Participation")} &nbsp;
              <span className='wellness-count' style={{color: '#FD7175', marginLeft: '20px'}}>{`(${this.props.t("Total")} : ${Total} ${this.props.t("Challenges")})`}</span>
            </div>
            <hr className='horizontal-line2' />
            <div className='fitness-wrapper'>
              <NewTotalPoints>
                <div>
                  <img src="/public/images/behaviorChallenges/wellness_challenge_count.png" />
                </div>
                <div>
                  <div>{this.props.t("Wellness Challenges Joined")}</div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    {participantCount.behavior_challenge_count}
                  </CountDiv>
                </div>
              </NewTotalPoints>
              <NewTotalPoints>
                <div>
                  <img src="/public/images/behaviorChallenges/classic_challenge_count.png" />
                </div>
                <div>
                  <div>{this.props.t("Classic Challenge Joined")} </div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    {participantCount.classic_challenge_count} 
                  </CountDiv>
                </div>
              </NewTotalPoints>
              <NewTotalPoints>
                <div>
                  <img src="/public/images/behaviorChallenges/survivor_challenge_count.png" />
                </div>
                <div>
                  <div>{this.props.t("Survivor Challenge Joined")}</div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    {participantCount.survivor_challenge_count}
                  </CountDiv>
                </div>
              </NewTotalPoints>
              <NewTotalPoints>
                <div>
                  <img src="/public/images/behaviorChallenges/group_challenge_count.png" />
                </div>
                <div>
                  <div>{this.props.t("Group Challenge Joined")}</div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    {participantCount.group_challenge_count}
                  </CountDiv>
                </div>
              </NewTotalPoints>
            </div>
          </div>
        </InitativeCard>:null} */}
      </div>
    )
  }
}
WellnessWellbeing.propTypes = {
  userModal: PropTypes.func,
  user: PropTypes.object,
  interest: PropTypes.object,
  dailyActivityData: PropTypes.object,
  userRecognitionCount: PropTypes.array,
  history: PropTypes.object.isRequired,
  workoutActivityCount: PropTypes.object,
  adventureScoreBoard: PropTypes.object,
  fetchAdventureScoreBoard: PropTypes.func.isRequired,
  getChallengeParticipation: PropTypes.object,
  participantCount: PropTypes.object,
  t: PropTypes.func,
  companyBranding: PropTypes.object,
  wellnessInterests: PropTypes.array,
  fetchWellnessInterests: PropTypes.func.isRequired,
  fitnessGoals:PropTypes.array,
  fetchFitnessGoals:PropTypes.func,
  selectedFitnessGoals:PropTypes.array
};

const mapStateToProps = (state) => ({
  adventureScoreBoard: state.education.adventureScoreBoard,
  participantCount: state.challenges.participantCount,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
  wellnessInterests: state.register.wellnessInterests,
  user: state.profileData.user,
  fitnessGoals: state.register.fitnessGoals,
  selectedFitnessGoals: state.profileData.wellnessGoals,
  interest: state.profileData.interest,
});

const mapDispatchToProps = (dispatch) => ({
  fetchWellnessInterests: () => dispatch(getWellnessInterests()),
  fetchAdventureScoreBoard: () => dispatch(fetchAdventureScoreBoard()),
  getChallengeParticipation: (year) => dispatch(getChallengeParticipation(year)),
  fetchFitnessGoals: () => dispatch(getFitnessGoals()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WellnessWellbeing));